import type { PersonalizationResult as Result } from "../../lib/types";

interface Props {
  data: Result;
}

export function PersonalizationResult({ data }: Props) {
  const rows: Array<[string, string | number]> = [
    ["Leads total", data.total ?? 0],
    ["Personalized", data.personalized ?? 0],
    ["Failed", data.failed ?? 0],
  ];
  const successes = Array.isArray(data.successes) ? data.successes : [];
  const failures = Array.isArray(data.failures) ? data.failures : [];

  return (
    <div className="result">
      <h3>Summary</h3>
      <div className="stats">
        {rows.map(([label, value]) => (
          <div className="stat" key={label}>
            <span className="label">{label}</span>
            <span className="value">{value}</span>
          </div>
        ))}
      </div>

      <h3>Personalized ({successes.length})</h3>
      {successes.length === 0 ? (
        <p className="empty">No personalized lines generated.</p>
      ) : (
        successes.map((s, i) => (
          <div className="contact" key={`s-${i}`}>
            <div className="contact-top">
              <span className="contact-name">{s.company ?? "(no company)"}</span>
            </div>
            {s.email && <div className="contact-email">{s.email}</div>}
            <div className="rationale">{s.line ?? ""}</div>
          </div>
        ))
      )}

      <h3>Failed ({failures.length})</h3>
      {failures.length === 0 ? (
        <p className="empty">No failures.</p>
      ) : (
        failures.map((f, i) => (
          <div className="contact" key={`f-${i}`}>
            <div className="contact-top">
              <span className="contact-name">{f.company ?? "(no company)"}</span>
            </div>
            {f.email && <div className="contact-email">{f.email}</div>}
            {f.reason && (
              <>
                <div className="rationale-label">Reason</div>
                <div className="rationale">{f.reason}</div>
              </>
            )}
            {f.rejected_output && (
              <>
                <div className="rationale-label">Rejected output</div>
                <pre>{f.rejected_output}</pre>
              </>
            )}
          </div>
        ))
      )}
    </div>
  );
}
